import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import SingleColumnTemplate from '../../../../../../../ui/layouts/SingleColumnTemplate';
import Button from '../../../../../../../ui/canon/Button';

const SuccessionCfaDisclaimer = ({ updateStep, step, currentUser, intl }) => {
  const company = currentUser?.company;

  return (
    <SingleColumnTemplate>
      <div className="bg-[var(--succession-bg-primary)] rounded-lg shadow-succession-lg p-8 border border-[var(--succession-border)]">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-[var(--succession-text-primary)] mb-6">
            <FormattedMessage id="calculators.cfa.tool_disclaimer"/>
          </h2>
          
          <div 
            className="text-[var(--succession-text-secondary)] leading-relaxed mb-8 text-left"
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage(
                { id: 'calculators.cfa.disclaimer_copy' }, 
                { company_name: company?.display_name || 'FindBob' }
              )
            }} 
          />
        </div>
        
        <div className="text-center">
          <Button
            variant="primary"
            size="lg"
            onClick={() => updateStep(step + 1)}
            className="px-8 py-3 text-lg"
          >
            <FormattedMessage id="calculators.cfa_wizard.generate" />
          </Button>
        </div>
      </div>
    </SingleColumnTemplate>
  );
};

export default injectIntl(SuccessionCfaDisclaimer); 